module.exports = __webpack_public_path__ + "img/desktop-elbow-6_56x74.214986e8.png";